import React from "react";

// Lightweight full-screen overlay showing a progress bar and reassuring copy.
export default function ProgressOverlay({ visible, percent, message }) {
  if (!visible) return null;
  const pct = Math.round(percent ?? 0);
  return (
    <div style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.45)",
      display: "grid",
      placeItems: "center",
      zIndex: 2000,
    }}>
      <div style={{
        width: 520,
        maxWidth: "92%",
        background: "#fff",
        borderRadius: 12,
        padding: 20,
        boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
      }}>
        <h5 style={{ margin: 0 }}>Creating your link…</h5>
        <p style={{ marginTop: 8, color: "#555" }}>
          This usually takes 35–50 seconds. Please keep this tab open.
        </p>
        <div style={{ height: 10, background: "#eee", borderRadius: 6, overflow: "hidden", marginTop: 6 }}>
          <div style={{ width: `${pct}%`, height: 10, background: "#4f46e5", transition: "width 280ms ease" }} />
        </div>
        <div style={{ marginTop: 10, color: "#666" }}>{message ?? (pct < 90 ? "Working…" : "Finalizing…")}</div>
      </div>
    </div>
  );
}